var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.internalValue),function(id){return (_vm.$store.getters.scopes[id])?_c('label',{staticClass:"label scope",style:({background:_vm.$store.getters.scopes[id].color}),attrs:{"title":_vm.$store.getters.scopes[id].name}},[_vm._v(_vm._s(_vm.$store.getters.scopes[id].slug.substr(0,1)))]):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16095ce6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scopes.vue
// module id = 387
// module chunks = 0